@use '@design/components/custom-scroll/custom-scroll' as *;

.tableScrollContainer {
  position: relative;
  overflow: auto;
  @include custom-scroll-minimal;
  flex: 1 1 0;

  th,
  td {
    padding-inline: 10px;
  }
}

.tableCellHighlighted {
  background-color: var(--text-inverse);

  tr:hover > & {
    background-color: var(--surface-hover);
  }
}

.companyCellWrapper {
  max-width: 180px;
}

.styledDateCell {
  > :global(span) {
    font-family: var(--font-roboto-mono);
  }
}
